import { makeStyles } from "@material-ui/core/styles";
import styled from "styled-components";
import { colors } from "../../../../components/theme";

export const Message = styled.section`
  width: 100%;
  min-height: 50px;
  background-color: ${colors.help};
  margin-bottom: 35px;
  margin-top: 0px;
  border-radius: 5px;
  padding: 12px;
`;

export const WrapperForm = styled.article`
  background-color: #ffffff;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 20px;
  width: 100%;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
`;


export const useStyles = makeStyles((theme) => ({
  buttons: {
    width: "100%",
    display: "inline-block",
    marginTop: "20px",
    height: "40px",
    color: "#560e1a",
  },
  row: {
    boxShadow: "0 0 0 !important",
  },
}));
